<div class="mt-2 flex items-center justify-between gap-4">
  <div class="flex flex-row items-center">
    <button
      type="button"
      [matMenuTriggerFor]="langMenu"
      class="flex items-center gap-2 rounded-md px-2 py-1 text-sm text-layout-sidenav-text hover:bg-black/5 hover:text-primary-color dark:text-layout-dark-sidenav-text dark:hover:bg-white/10"
    >
      <img
        alt=""
        class="h-4 w-6 rounded-sm object-cover"
        [src]="flagFor(languageService.activeLanguage$ | async)"
      />
      <span>{{
        'common.language.' +
          ((languageService.activeLanguage$ | async) | uppercase) | transloco
      }}</span>
      <fa-icon
        [icon]="faChevronDown"
        size="xs"
        class="ml-1 opacity-70"
      ></fa-icon>
    </button>

    <mat-menu #langMenu="matMenu" xPosition="before">
      @for (lang of langs$ | async; track lang.id) {
        <button mat-menu-item type="button" (click)="setLanguage(lang.id)">
          <img
            alt=""
            class="mr-2 inline-block h-4 w-6 rounded-sm object-cover align-middle"
            [src]="flagFor(lang.id)"
          />
          <span class="align-middle">{{
            'common.language.' + lang.label | transloco
          }}</span>
          @if ((languageService.activeLanguage$ | async) === lang.id) {
            <fa-icon
              [icon]="faCheck"
              size="xs"
              class="ml-2 align-middle text-primary-color"
            ></fa-icon>
          }
        </button>
      }
    </mat-menu>
  </div>

  <div
    class="inline-flex items-center gap-1 rounded-full border border-black/10 bg-black/5 p-1 dark:border-white/10 dark:bg-white/5"
  >
    <button
      type="button"
      [attr.aria-label]="'theme.LIGHT_MODE' | transloco"
      [attr.aria-pressed]="(darkMode$ | async) === false"
      (click)="setDarkMode(false)"
      class="flex h-7 w-7 items-center justify-center rounded-full transition-colors"
      [ngClass]="
        (darkMode$ | async) === false
          ? 'bg-primary-color text-white'
          : 'text-layout-sidenav-text hover:text-primary-color dark:text-layout-dark-sidenav-text'
      "
    >
      <fa-icon [icon]="faSun"></fa-icon>
    </button>
    <button
      type="button"
      [attr.aria-label]="'theme.DARK_MODE' | transloco"
      [attr.aria-pressed]="(darkMode$ | async) === true"
      (click)="setDarkMode(true)"
      class="flex h-7 w-7 items-center justify-center rounded-full transition-colors"
      [ngClass]="
        (darkMode$ | async) === true
          ? 'bg-primary-color text-white'
          : 'text-layout-sidenav-text hover:text-primary-color dark:text-layout-dark-sidenav-text'
      "
    >
      <fa-icon [icon]="faMoon"></fa-icon>
    </button>
  </div>
</div>
